import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { HrisLocationFragmentDoc } from './HrisLocationListContainer.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HrisLocationSidebarQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type HrisLocationSidebarQuery = { __typename?: 'Query', HrisLocation?: { __typename?: 'HrisLocation', manuallyLinked: boolean, activeHrisEmployeeCount: number, id: number, name: string, createdAt: string, address?: { __typename?: 'Address', id: string, lineOne: string, lineTwo?: string | null, city: string, usState?: USState | null, country: string, postalCode: string } | null, hrisIntegration?: { __typename?: 'HrisIntegration', id: string, hrisProvider?: string | null } | null, group?: { __typename?: 'Location', id: number, name: string } | null } | null };


export const HrisLocationSidebarDocument = gql`
    query HrisLocationSidebar($id: Int!) {
  HrisLocation(id: $id) {
    ...HrisLocation
    address {
      id
      lineOne
      lineTwo
      city
      usState
      country
      postalCode
    }
    manuallyLinked
    activeHrisEmployeeCount
    hrisIntegration {
      id
      hrisProvider
    }
  }
}
    ${HrisLocationFragmentDoc}`;

/**
 * __useHrisLocationSidebarQuery__
 *
 * To run a query within a React component, call `useHrisLocationSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisLocationSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisLocationSidebarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHrisLocationSidebarQuery(baseOptions: Apollo.QueryHookOptions<HrisLocationSidebarQuery, HrisLocationSidebarQueryVariables> & ({ variables: HrisLocationSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisLocationSidebarQuery, HrisLocationSidebarQueryVariables>(HrisLocationSidebarDocument, options);
      }
export function useHrisLocationSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisLocationSidebarQuery, HrisLocationSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisLocationSidebarQuery, HrisLocationSidebarQueryVariables>(HrisLocationSidebarDocument, options);
        }
export type HrisLocationSidebarQueryHookResult = ReturnType<typeof useHrisLocationSidebarQuery>;
export type HrisLocationSidebarLazyQueryHookResult = ReturnType<typeof useHrisLocationSidebarLazyQuery>;
export type HrisLocationSidebarQueryResult = Apollo.QueryResult<HrisLocationSidebarQuery, HrisLocationSidebarQueryVariables>;